import React, { useState } from 'react';
import useAsync from '../../hooks/useAsync';
import UserServices from '../../services/UserServices';
import UserStatus from './TogelButton/UserStatus';

function UserManagement() {
  const { data, error, isLoading, run } = useAsync(UserServices.getAllUser);
  const [searchTerm, setSearchTerm] = useState('');

  // Filter the data based on the search term
  const filteredData = data?.data?.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(user.mobile_no).includes(searchTerm)
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>User Manager <span className="badge bg-warning">{filteredData?.length}</span></h2>
      </div>
      <div className="sub-title-box">
        <div className="sub-title-box-left">
          <p>User List</p>
        </div>
        <div className="sub-title-box-right">
          <button className="excel-btn"><img src="img/excel.svg" alt="Excel" />Download</button>
        </div>
      </div>
      <div className="container-box px-0 user-manager">
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input 
              type="search" 
              name="search" 
              placeholder="Search by Name or Mobile No." 
              value={searchTerm} 
              onChange={handleSearchChange} 
            />
            <button className="search-btn">Search</button>
          </div>
        </div>
        <div className="container-box-inner">
          <table id="example" className="table table-striped" style={{width: '100%'}}>
            <thead>
              <tr>
                <th>#</th>
                <th>User Type</th>
                <th>Name</th>
                <th>Mobile No.</th>
                <th>City</th>
                <th>District</th>
                <th>State</th>
                <th>Registration Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredData?.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td><span className="usertype">User</span></td>
                  <td>{user.name}</td>
                  <td>+91 {user.mobile_no}</td>
                  <td>{user.city}</td>
                  <td>{user.district}</td>
                  <td>{user.state}</td>
                  <td>{new Date(user.created_at).toLocaleDateString()}</td>
                  <td className="status-toggle">
                    <UserStatus user={user} page={"user"} onSuccess={run} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UserManagement;
